export default "__VITE_ASSET__CI33K_UY__"